const htmlToElement = (html: string) => {
  const template = document.createElement('template');
  template.innerHTML = html.trim();
  return <HTMLElement>template.content.firstChild;
};

export default htmlToElement;
